/**
 * Generate a consistent color from a string (name)
 * This creates a deterministic color based on the hash of the string
 * @param {string} string - The string to generate color from
 * @returns {string} A hex color code
 */
export function stringToColor(string) {
  if (!string) return "#9e9e9e"; // Default gray color

  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Generate a color with good saturation and lightness for readability
  const hue = hash % 360;
  const saturation = 45 + (hash % 30); // 45-75%
  const lightness = 50 + (hash % 15); // 50-65%

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

/**
 * Generate avatar sx props including background color from name
 * @param {string} name - The name to generate color from
 * @returns {object} MUI sx prop object with bgcolor
 */
export function stringAvatar(name) {
  return {
    bgcolor: stringToColor(name),
    color: "#fff",
  };
}
